function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "reset-values");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15.3,
    height: 18.36,
    viewBox: "0 0 15.3 18.36"
  }, props), _ref, React.createElement("path", {
    d: "M7.65,1.53h0V0h0L4.54,2.82,7.62,5.64h0V4h0a5.17,5.17,0,0,1,3.92,8.54l1.82,1.68A7.64,7.64,0,0,0,7.65,1.53Zm0,12.82A5.17,5.17,0,0,1,3.67,5.87L1.77,4.29A7.65,7.65,0,0,0,7.61,16.83v1.53l3-2.79-3-2.79Z",
    style: {
      "fill": "#fff"
    }
  }));
};

export default __webpack_public_path__ + "static/media/reset-values.dfcdd05e.svg";
export { SvgComponent as ReactComponent };